(() => {
  function setup(root) {
    if (root.dataset.kccReady || root.dataset.account !== 'signed-in') return;
    root.dataset.kccReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-kcc-labels]').textContent);
    const status = root.querySelector('[data-kcc-status]');
    const result = root.querySelector('[data-kcc-result]');
    const retry = root.querySelector('[data-kcc-retry]');
    const purchase = root.querySelector('[data-kcc-purchase]');
    const endpoint = root.dataset.endpoint;
    if (!/^\/apps\/kiive-collection\/quote$/.test(endpoint)) return;
    let expiryTimer;
    let requestNumber = 0;
    let activeQuote;
    const ownerPresentation = active => document.documentElement.classList.toggle('kcc-owner-active', active);
    const unavailable = () => {
      activeQuote = undefined;
      purchase.disabled = true;
      result.hidden = true;
      ownerPresentation(false);
      status.hidden = false;
      status.textContent = labels.unavailable;
      retry.hidden = false;
    };
    const titles = (selector, items) => {
      const list = root.querySelector(selector); list.replaceChildren();
      for (const item of items.length ? items : [{title: labels.none}]) {
        const li = document.createElement('li'); li.textContent = item.title; list.append(li);
      }
    };
    async function load() {
      const currentRequest = ++requestNumber;
      activeQuote = undefined; purchase.disabled = true;
      clearTimeout(expiryTimer);
      result.hidden = true; retry.hidden = true; status.hidden = false; status.textContent = labels.loading;
      try {
        // Allow the bounded full-history read and both protected hold checks to finish.
        const response = await fetch(endpoint, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}, signal:AbortSignal.timeout(45000)});
        if (!response.ok) throw new Error('unavailable');
        const quote = await response.json();
        if (currentRequest !== requestNumber || !root.isConnected) return;
        if (quote.contractVersion !== 'kiive-collection.quote.v1' || quote.developmentFixture !== false || typeof quote.checkoutAvailable !== 'boolean' || quote.catalogVersion !== 'KIIVE_CC_2026_10_01_V1' || quote.currency !== 'USD' || !Number.isSafeInteger(quote.subtotalCents) || quote.subtotalCents < 0 || quote.subtotalCents > 79900 || !Array.isArray(quote.owned) || !Array.isArray(quote.missing) || quote.owned.length + quote.missing.length !== 23 || [...quote.owned, ...quote.missing].some(item => typeof item.key !== 'string' || !item.key || typeof item.title !== 'string' || !item.title) || new Set([...quote.owned, ...quote.missing].map(item => item.key)).size !== 23 || quote.allOwned !== (quote.missing.length === 0) || (quote.allOwned && (quote.subtotalCents !== 0 || quote.checkoutAvailable)) || !/^[A-Za-z0-9_-]{43}$/.test(quote.quoteToken || '') || !Number.isSafeInteger(quote.expiresAt) || quote.expiresAt <= Date.now() || quote.expiresAt > Date.now() + 330000) throw new Error('invalid_quote');
        root.querySelector('[data-kcc-subtotal]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'}).format(quote.subtotalCents / 100);
        titles('[data-kcc-owned]', quote.owned); titles('[data-kcc-missing]', quote.missing);
        root.querySelector('[data-kcc-owned-count]').textContent = `(${quote.owned.length})`;
        root.querySelector('[data-kcc-missing-count]').textContent = `(${quote.missing.length})`;
        ownerPresentation(true);
        activeQuote = quote;
        purchase.disabled = !quote.checkoutAvailable;
        purchase.textContent = labels.purchase;
        purchase.hidden = quote.allOwned || !quote.checkoutAvailable;
        retry.hidden = quote.allOwned || quote.checkoutAvailable;
        root.querySelector('[data-kcc-downloads]').hidden = !quote.allOwned;
        status.textContent = quote.allOwned ? labels.allOwned : quote.checkoutAvailable ? '' : labels.unavailable;
        status.hidden = !status.textContent; result.hidden = false;
        expiryTimer = setTimeout(unavailable, quote.expiresAt - Date.now());
      } catch {
        if (currentRequest === requestNumber && root.isConnected) unavailable();
      }
    }
    purchase.addEventListener('click', async () => {
      const quote = activeQuote, currentRequest = requestNumber;
      if (purchase.disabled || !quote?.checkoutAvailable || quote.allOwned || quote.expiresAt <= Date.now()) return;
      purchase.disabled = true; status.hidden = false; status.textContent = labels.preparing;
      try {
        const response = await fetch('/apps/kiive-collection/purchase', {method:'POST', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json','Content-Type':'application/json'}, body:JSON.stringify({quoteToken:quote.quoteToken}), signal:AbortSignal.timeout(10000)});
        if (!response.ok) throw new Error('unavailable');
        const checkout = await response.json();
        const url = new URL(checkout.checkoutUrl);
        if (!/^gid:\/\/shopify\/DraftOrder\/\d+$/.test(checkout.draftId || '') || url.protocol !== 'https:' || url.username || url.password || !['7b05a8.myshopify.com','kiiveaudio.com','www.kiiveaudio.com','checkout.shopify.com'].includes(url.hostname)) throw new Error('invalid_checkout');
        if (currentRequest !== requestNumber || !root.isConnected || quote.expiresAt <= Date.now()) return;
        window.location.assign(url.href);
      } catch {
        if (currentRequest === requestNumber && root.isConnected) unavailable();
      }
    });
    retry.addEventListener('click', load); load();
  }
  const init = scope => scope.querySelectorAll('[data-kcc]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
